'use client'

import { motion, useReducedMotion } from 'framer-motion'
import { TbArrowWaveRightUp as Signal } from 'react-icons/tb'

export default function CinematicServiceBand({
  idealTitle,
  idealBody,
  commercialTitle,
  commercialBody,
  serviceTitle,
}: {
  idealTitle: string
  idealBody: string
  commercialTitle: string
  commercialBody: string
  serviceTitle: string
}) {
  const reduceMotion = useReducedMotion()

  return (
    <section className="relative overflow-hidden bg-[#f1a54e] py-20 text-[#10374d] md:py-28">
      <div className="absolute inset-0 opacity-25 [background-image:linear-gradient(rgba(16,55,77,.18)_1px,transparent_1px),linear-gradient(90deg,rgba(16,55,77,.18)_1px,transparent_1px)] [background-size:42px_42px]" />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-6 md:px-10 lg:grid-cols-[1fr_0.72fr_1fr] lg:items-center">
        <motion.article
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          className="border-t-2 border-[#10374d]/30 pt-7"
        >
          <h2 className="font-heading text-3xl font-black md:text-5xl">{idealTitle}</h2>
          <p className="mt-6 text-lg leading-relaxed text-[#10374d]/82 md:text-xl">{idealBody}</p>
        </motion.article>

        <div className="relative mx-auto grid aspect-square w-full max-w-[19rem] place-items-center">
          {[0, 1, 2].map((ring) => (
            <motion.span
              key={ring}
              className="absolute rounded-full border border-[#10374d]/30"
              style={{ inset: `${ring * 13}%` }}
              animate={reduceMotion ? undefined : { rotate: ring % 2 === 0 ? 360 : -360 }}
              transition={{ duration: 18 + ring * 7, repeat: Infinity, ease: 'linear' }}
            >
              <span className="absolute left-1/2 top-0 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#10374d]" />
            </motion.span>
          ))}
          <motion.div
            animate={reduceMotion ? undefined : { y: [0, -10, 0], rotate: [0, 3, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
            className="relative z-10 grid h-32 w-32 place-items-center rounded-full bg-[#10374d] text-[#f1a54e] shadow-2xl"
          >
            <Signal className="h-14 w-14" />
          </motion.div>
          <p className="absolute -bottom-2 max-w-64 text-center text-xs font-black uppercase tracking-[0.18em]">
            {serviceTitle}
          </p>
        </div>

        <motion.article
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          className="border-t-2 border-[#10374d]/30 pt-7"
        >
          <h2 className="font-heading text-3xl font-black md:text-5xl">{commercialTitle}</h2>
          <p className="mt-6 text-lg leading-relaxed text-[#10374d]/82 md:text-xl">{commercialBody}</p>
        </motion.article>
      </div>
    </section>
  )
}
